export const APP_PAGE = 'ping-settings-page';
export const APP_TITLE = 'ping-settings-app-title';
export const FONT_UPGRADE = 'ping-settings-font-upgrade';
export const HEIGHT_ANIMATOR = 'ping-settings-height-animator';

export const EXPERT_SECTION = 'ping-settings-expert-section';
export const EXPERT_TOGGLE_SWITCH = 'ping-settings-expert-toggle-switch';

export const PUSH_SECTION = 'ping-settings-push-section';
export const PUSH_TURN_ON_BUTTON = 'ping-settings-push-turn-on-button';
export const PUSH_TOGGLE_SWITCH = 'ping-settings-push-toggle-switch';
export const PERMISSION_DENIED_ALERT = 'ping-settings-page-permission-denied-alert';

export const MOBILE_SECTION = 'ping-settings-mobile-section';
export const MOBILE_SECTION_LINK = 'ping-settings-mobile-section-link';

export const CHEVRON_UP = 'ping-settings-section-chevron-up';
export const CHEVRON_DOWN = 'ping-settings-section-chevron-down';
export const CHANNEL_HEADER = 'ping-settings-channel-header';
export const CHANNEL_DESCRIPTION = 'ping-settings-channel-description';
export const SETTING_GROUP = 'ping-setting-group';
export const SETTING_SUBSECTION = 'ping-settings-subsection';
export const RESTAURANTS_LINK = 'ping-settings-restaurants-link';
